import { createSelector } from '@reduxjs/toolkit';
import { selectSaleTypes } from 'shared/selectors/jsonQuery';
import { prepareValue } from './utils';
import { ESaleType } from '../../../../packages/api-models/common/json_query';

const FLAT_OLD_TYPES = [ESaleType.Free, ESaleType.Alternative];

export const selectFlatOldSaleTypeValue = createSelector(selectSaleTypes, value =>
  prepareValue({ value, allowedValues: FLAT_OLD_TYPES }),
);
